import PropTypes from 'prop-types';
import {compose} from 'recompose';
import {Step, StepContent, StepLabel, Typography, withStyles} from '@material-ui/core';
import styles from './styles';
import {withTranslation} from 'react-i18next';
import React, {Fragment, useState} from 'react';
import {StepperIcon, TrackingStepEvaluation} from '../index';
import classNames from 'classnames';
import {DateService} from '../../../../../services/util/DateService';
import moment from 'moment';
import {getStopStatusString, StopStatus} from '../../../../../services/enums/StopStatus';
import {ExpandLess, ExpandMore} from '@material-ui/icons';
import {StopIdLabel} from '../../../../index';


const StopDeliveredStep = (props) => {
  const {className, classes, t, stop, trackingStop, plannedStopDelivery} = props;

  trackingStop.trackingSteps.sort((a, b) => new Date(a.eventTimeStamp) - new Date(b.eventTimeStamp));

  const [active, setActive] = useState(false);
  const rootClassName = classNames(classes.root, className);

  return (
    <Step
      active={active}
      className={rootClassName}
      completed
    >
      <StepLabel
        classes={{error: classes.noErrorClass}}
        error={stop.stopStatus === StopStatus.CanNotDeliver}
        StepIconComponent={StepperIcon}
      >
        <div
          className={classes.stepperLabel}
          onClick={() => setActive(!active)}
        >
          <Typography
            variant={'subtitle1'}
          >
            {`[${DateService.displayDateTime(stop.deliverTime)}] - ${t(getStopStatusString(stop.stopStatus))}: ${stop.stopNumber}`}
          </Typography>
          {active ? <ExpandLess/> : <ExpandMore/>}
        </div>
      </StepLabel>
      <StepContent>
        <Fragment>
          <Typography><strong>{t('tourStopId')}:</strong> <StopIdLabel stop={stop}/></Typography>
          <Typography><strong>{t('lastName')}:</strong> {stop.lastName}</Typography>
          <Typography><strong>{t('address')}:</strong> {stop.address.streetAndNumber}</Typography>
          <Typography><strong>{t('driverInfo')}:</strong> {stop.driverInfo}</Typography>
          <Typography><strong>{t('plannedStopDelivery')}:</strong> {DateService.displayDateTime(plannedStopDelivery)}</Typography>
          <Typography>
            <strong>{t('differenceToPlannedStopDelivery')}:</strong> {moment.duration(moment(stop.deliverTime).diff(moment(plannedStopDelivery))).format('h:mm:ss', {trim: false})}
          </Typography>
          <Typography><strong>{t('trackingEvaluation')}</strong></Typography>
          <div className={classes.trackingEvaluation}>
            {trackingStop.trackingSteps.map((step, index) =>
              <TrackingStepEvaluation
                deliveryTime={stop.deliverTime}
                key={index}
                trackingStep={step}
                TrackingStepEvaluation
              />
            )}
          </div>
        </Fragment>
      </StepContent>
    </Step>
  );
};


StopDeliveredStep.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  plannedStopDelivery: PropTypes.string.isRequired,
  stop: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  trackingStop: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), withTranslation())(StopDeliveredStep);
